<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid work-list-page-container"
    >
      <div>
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mb-1">
              {{
                woundConfig?.pageTitleKey
                  ? (woundConfig?.pageTitleKey | translate)
                  : ("workList" | translate)
              }}
            </h3>
          </div>

          <!-- Filter Button -->
          <div
            [hidden]="woundListLoading || woundCards.length === 0"
            class="d-flex align-items-center gap-3"
          >
            <button
              class="btn btn-icon btn-active-light-primary cursor-pointer"
              (click)="$event.stopPropagation()"
              (mouseenter)="showTooltip($event, 'filter')"
              (mouseleave)="hideTooltip()"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#woundFilterCollapse"
              aria-expanded="false"
              aria-controls="woundFilterCollapse"
            >
              <i class="fa-solid fa-filter"></i>
            </button>
          </div>
        </div>

        <!-- Custom tooltip element -->
        <div
          class="risk-tooltip"
          *ngIf="activeTooltip"
          [style.left.px]="activeTooltip.x"
          [style.top.px]="activeTooltip.y"
        >
          {{ activeTooltip.text }}
        </div>

        <!-- Filter Section -->
        <div>
          <div class="collapse mb-8" id="woundFilterCollapse">
            <form (ngSubmit)="applyFilter()">
              <div class="row align-items-end">
                <!-- Name Surname -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "nameSurname" | translate }}
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="filterForm.name"
                    class="form-control fs-14"
                    [placeholder]="'nameSurname' | translate"
                    name="name"
                  />
                </div>

                <!-- PID -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "pid" | translate }}
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="filterForm.pid"
                    class="form-control fs-14"
                    [placeholder]="'filterByPID' | translate"
                    name="pid"
                  />
                </div>

                <!-- Start Date -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "startDate" | translate }}
                  </label>
                  <input
                    type="date"
                    [(ngModel)]="filterForm.startDate"
                    class="form-control fs-14"
                    name="startDate"
                    max="9999-12-31"
                    (input)="validateDateInput($event, 'startDate')"
                  />
                </div>

                <!-- End Date -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "endDate" | translate }}
                  </label>
                  <input
                    type="date"
                    [(ngModel)]="filterForm.endDate"
                    class="form-control fs-14"
                    name="endDate"
                    max="9999-12-31"
                    (input)="validateDateInput($event, 'endDate')"
                  />
                </div>

                <!-- Wound Category -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "woundCategory" | translate }}
                  </label>
                  <app-select
                    [(ngModel)]="filterForm.woundCategory"
                    [items]="translatedWoundCategories"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="true"
                    [placeholder]="'woundCategory' | translate"
                    name="woundCategory"
                    appendTo="body"
                  >
                  </app-select>
                </div>

                <!-- Wound Type -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "woundType" | translate }}
                  </label>
                  <app-select
                    [(ngModel)]="filterForm.woundType"
                    [items]="translatedWoundTypes"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="true"
                    [placeholder]="'woundType' | translate"
                    name="woundStatus"
                    appendTo="body"
                  >
                  </app-select>
                </div>

                <!-- Wound Status -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "woundStatus" | translate }}
                  </label>
                  <app-select
                    [(ngModel)]="filterForm.status"
                    [items]="translatedStatuses"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="true"
                    [placeholder]="'woundStatus' | translate"
                    name="woundStatus"
                    appendTo="body"
                  >
                  </app-select>
                </div>

                <!-- Filter Actions (UI only) -->
                <div class="col-xl-3 col-lg-4 mt-4 col-sm-6">
                  <div class="d-flex justify-content-start gap-4">
                    <button
                      type="button"
                      class="btn btn-secondary cursor-pointer fs-14 flex-grow-1"
                      (click)="clearFilter()"
                    >
                      {{ "clear" | translate }}
                    </button>

                    <button
                      type="submit"
                      class="btn btn-primary cursor-pointer fs-14 flex-grow-1"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- LIST CONTAINER -->
        <div>
          <!-- Loading -->
          <div
            *ngIf="woundListLoading"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>

          <!-- Empty state -->
          <div
            *ngIf="!woundListLoading && woundCards.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "noWounds" | translate }}
          </div>

          <!-- GRID HEADER -->
          <div
            class="grid-header"
            *ngIf="
              (woundColumns?.length || 0) > 0 &&
              !woundListLoading &&
              woundCards.length > 0
            "
          >
            <ng-container *ngFor="let col of woundColumns || []">
              <div
                [ngClass]="getColClass(col)"
                (click)="
                  ['createdDate', 'patientName', 'woundStatus'].includes(
                    col.key
                  )
                    ? onSort(col.key)
                    : null
                "
                [class.cursor-pointer]="
                  ['createdDate', 'patientName', 'woundStatus'].includes(
                    col.key
                  )
                "
              >
                {{ col.labelKey | translate }}
                <ng-container *ngIf="filterForm.sortBy === col.key">
                  <i
                    class="fa-solid ms-1"
                    style="font-size: 0.65em !important; vertical-align: middle"
                    [ngClass]="{
                      'fa-chevron-down': filterForm.sortDirection === 'desc',
                      'fa-chevron-up': filterForm.sortDirection === 'asc',
                    }"
                  ></i>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <!-- CARD LIST -->
          <ng-container *ngIf="!woundListLoading && woundCards.length > 0">
            <app-dynamic-list
              *ngFor="let card of woundCards"
              [item]="card"
              [columns]="woundColumns"
              [actions]="woundActions"
              [disableScrollableItems]="true"
              (click)="onCardClick(card)"
            >
            </app-dynamic-list>
          </ng-container>
        </div>

        <!-- PAGINATION -->
        <ng-container *ngIf="!woundListLoading && woundCards.length > 0">
          <div class="d-flex flex-stack flex-wrap pt-10">
            <div class="d-flex align-items-center gap-6">
              <div class="flex align-items-center gap-2">
                <label class="me-2 fs-6 fw-semibold text-gray-700">
                  {{ "pageSize" | translate }}:
                </label>
                <app-page-size-selector
                  [sizes]="pageSizes"
                  [selectedSize]="pageSize"
                  (sizeChange)="changePageSize($event)"
                >
                </app-page-size-selector>
              </div>
              <div class="fs-6 fw-semibold text-gray-700">
                {{ "showing" | translate }} {{ woundCards.length }}
                {{ "of" | translate }} {{ totalWounds }}
                {{ "items" | translate }}
              </div>
            </div>

            <ul class="pagination">
              <li
                class="page-item previous cursor-pointer"
                [class.disabled]="currentPage === 1"
              >
                <a class="page-link" (click)="changePage(currentPage - 1)">
                  <i class="previous"></i>
                </a>
              </li>

              <li
                *ngFor="let page of [].constructor(totalPage); let i = index"
                class="page-item cursor-pointer"
                [class.active]="currentPage === i + 1"
              >
                <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
              </li>

              <li
                class="page-item next cursor-pointer"
                [class.disabled]="currentPage === totalPage"
              >
                <a class="page-link" (click)="changePage(currentPage + 1)">
                  <i class="next"></i>
                </a>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
